import { render } from "./ArchiveDemoScreen.vue?vue&type=template&id=ac6853ea&scoped=true"
import script from "./ArchiveDemoScreen.vue?vue&type=script&lang=js"
export * from "./ArchiveDemoScreen.vue?vue&type=script&lang=js"

import "./ArchiveDemoScreen.vue?vue&type=style&index=0&id=ac6853ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac6853ea"]])

export default __exports__